module.exports = __webpack_public_path__ + "img/DIKASIR-payment.e1e9df91.png";